import { createStyles } from '@mantine/core';
import gradient from '../../assets/backgrounds/gradient-1.png';
import gradient3 from '../../assets/backgrounds/gradient-3.png';

export const useStyles = createStyles( ( theme, { backgroundImage }: { backgroundImage: 'gradient' | 'stripeGradient' } ) => ( {
	container: {
		backgroundImage: `url(${backgroundImage === 'gradient' ? gradient : gradient3})`,
		backgroundSize: 'cover',
		backgroundPosition: 'center',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: '1rem',
		gap: '1rem',
	},

	withHeader: {
		minHeight: 'calc(100vh - 3.125rem)',
	},

	withoutHeader: {
		minHeight: '100vh',
	},
} ) );
